import IconCalendar from 'hb-react/shared/icons/Calendar';
import IconLocation from 'hb-react/shared/icons/Location';
import IconTrip from 'hb-react/shared/icons/Trip';

import {
  NETWORK_FEED_TYPE,
  GROUP_FEED_TYPE,
  MY_GROUPS_FEED_TYPE,
} from '../constants/FeedType';
import * as PostTypes from '../constants/PostTypes';

const getContentTypesUserCanCreate = ({
  currentNetwork,
  currentUser,
  configType,
}) => {
  let canCreateUserPost;
  let canCreateTrip;
  let canCreateEvent;
  let canCreateChecking;

  switch (configType) {
    case GROUP_FEED_TYPE:
      canCreateUserPost = true;
      canCreateTrip = false;
      canCreateEvent = false;
      canCreateChecking = false;
      break;
    case MY_GROUPS_FEED_TYPE:
      canCreateUserPost = false;
      canCreateTrip = false;
      canCreateEvent = false;
      canCreateChecking = false;
      break;
    case NETWORK_FEED_TYPE:
    default:
      canCreateUserPost = currentUser.display_feed_post_create_buttons;
      canCreateTrip = currentUser.display_trip_location_create_buttons;
      canCreateEvent =
        currentNetwork.network_configuration.events.accessible &&
        currentUser.users_can_create_events;
      canCreateChecking = currentUser.display_current_location_create_buttons;
      break;
  }

  return {
    [PostTypes.POST]: {
      type: PostTypes.POST,
      display: 'block',
      available: canCreateUserPost,
    },
    [PostTypes.TRIP]: {
      type: PostTypes.TRIP,
      icon: IconTrip,
      label: __('Trip'),
      display: 'button',
      available: canCreateTrip,
    },
    [PostTypes.EVENT]: {
      type: PostTypes.EVENT,
      icon: IconCalendar,
      label: __('Event'),
      display: 'button',
      available: canCreateEvent,
    },
    [PostTypes.CHECKIN]: {
      type: PostTypes.CHECKIN,
      icon: IconLocation,
      label: __('Check-in'),
      display: 'button',
      available: canCreateChecking,
    },
  };
};

export default getContentTypesUserCanCreate;
